SupportDropDownModel = require('./dropdowns')
SupportDropDownCombinationsModel = require('./dropdown_combinations')

class SupportCMSModel
  constructor: ->
    @init(null)
    @dropDowns = new SupportDropDownModel()
    @dropDownCombinations = new SupportDropDownCombinationsModel()

  init: (currentOrder) ->
    @isCurrentOrderSelected = if currentOrder then true else false
    window.Groupon.Support.CMS =
      Category : null
      SubCategory : null
      SearchInputIssue : null
      Content : null
    @flexibleStepThree = null
    @displayStatus = null
    @displayNotes = null
    @externalDealNotes = null
    @isRefundEligible = false
    @escalateToMerchant = false

  getContentObject : () ->
    window.Groupon.Support.CMS

  getCategory: () ->
    Groupon.Support.CMS.Category

  getSubCategory: () ->
    Groupon.Support.CMS.SubCategory

  getSearchInputIssue: () ->
    Groupon.Support.CMS.SearchInputIssue

  getContent : () ->
    Groupon.Support.CMS.Content

  getContentId : () ->
    Groupon.Support.CMS.Content?.id

  setSubCategory: (subCategory) ->
    Groupon.Support.CMS.SubCategory = subCategory

  setCategory: (category) ->
    Groupon.Support.CMS.Category = category

  setContent : (content) ->
    Groupon.Support.CMS.Content = content

  setSearchInputIssue: (searchInputIssue) ->
    Groupon.Support.CMS.SearchInputIssue =  searchInputIssue

  onUnloadStepOne: () ->

  onInitStepTwo: () ->

  onInitStepThree: () ->

  extendParams: (params) ->
    _.extend(Groupon.Support.CMS, params)

module.exports = SupportCMSModel
